import styled from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { Container } from './ColoredContainers';

export const ScreenWrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing._24px} 0`};
`;

export const QuestionWrapper = styled.div`
  @media (min-width: 600px) {
    min-height: 812px;
  }
`;

/**
 * Left-aligned screen content with the standard top padding shared across flow screens (Medicare
 * MBI, expectation-setting, helplines, coverage-loading) so content sits below the header rather
 * than hugging it.
 */
export const FlowContentBody = styled.div`
  text-align: left;
  padding-top: ${({ theme }) => theme.spacing._32px};
`;

export const FormContainer = styled.div`
  text-align: left;
  ${({ theme }) => appOverride({ nerva: 'box-shadow: none', default: theme.shadow.drop.gray })};
  border-radius: ${({ theme }) => theme.spacing._24px};
  padding: ${({ theme }) => `${theme.spacing._16px}`};
  margin-bottom: ${({ theme }) => theme.spacing._32px};
  background: ${appOverride({ nerva: 'transparent', default: Color.subscription.accent })};
`;

export const ProminentContainer = styled(Container)`
  ${({ theme }) => theme.shadow.drop.gray}
  padding: ${({ theme }) => theme.spacing._16px};
`;

const BUTTON_SIZE = 50;
const INSIDE_BUTTON_PADDING = 30;

const ButtonInfoContainer = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  background: ${Color.surface.muted};
  bottom: -${INSIDE_BUTTON_PADDING}px;
  border-radius: 30px 30px 0 0;
  text-align: left;
  padding: ${({ theme }) => `${theme.spacing._32px} ${theme.spacing._42px}`};
  padding-bottom: ${INSIDE_BUTTON_PADDING * 2 + BUTTON_SIZE}px;
  @media (min-height: 900px) {
    border-radius: 30px;
  }
`;

export const ButtonInfoContainerVariation = styled(ButtonInfoContainer)`
  padding: ${({ theme }) => `${theme.spacing._32px} ${theme.spacing._30px}`};
  padding-bottom: 112px;
`;
